import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Fss } from '../models/fss.model';
var OverviewService = /** @class */ (function () {
    function OverviewService(_http, _errorHandler) {
        this._http = _http;
        this._errorHandler = _errorHandler;
    }
    /**
     * updates specified entity via api
     * @param {number} airportID
     * @param {string} website
     * @return {Promise<any>}
     */
    OverviewService.prototype.putOverview = function (airportID, website) {
        var URL = environment.airportsApiUrl + "/airports/" + airportID;
        try {
            return this._http.put(URL, { website: website }).toPromise();
        }
        catch (e) {
            this._errorHandler.handleError(e);
            throw e;
        }
    };
    OverviewService.prototype.putIslandAirport = function (airport) {
        var URL = environment.airportsApiUrl + "/airports/island/" + airport.airportId;
        try {
            return this._http.put(URL, airport.serialize()).toPromise();
        }
        catch (e) {
            this._errorHandler.handleError(e);
            throw e;
        }
    };
    OverviewService.prototype.getFsses = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var URL, RESPONSE, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        URL = environment.airportsApiUrl + "/airports/fsses";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.get(URL).toPromise()];
                    case 2:
                        RESPONSE = _a.sent();
                        if (!RESPONSE) {
                            this._errorHandler.handleError(new Error('API did not return valid fss Obj'));
                        }
                        else {
                            return [2 /*return*/, (RESPONSE || []).map(function (d) { return Fss.parse(d); })];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this._errorHandler.handleError(e_1);
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return OverviewService;
}());
export { OverviewService };
